import {
    Button,
    Dialog,
    DialogTitle,
    Drawer,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    IconButton,
    List,
    ListItem,
    Switch, Typography
} from "@mui/material";
import React, {useCallback, useEffect, useRef, useState} from "react";
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import ProfileView from "../components/ProfileView";
import LoginView from "../components/LoginView";
import Privacy from "./Privacy";
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import {Transition} from "../components/Transition";
import MarkChatReadOutlinedIcon from '@mui/icons-material/MarkChatReadOutlined';
import {Feedback} from "../components/Feedback";
import {MobileTooltip} from "../components/Tooltip";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import DownloadingIcon from '@mui/icons-material/Downloading';
import LogoImage from "../assets/logo.svg";
const Profile = React.memo(ProfileBase);
function ProfileBase({
                                    setEnableQuickScroll,
                                    enableQuickScroll,
                                    setShowQuickScroll,
                                    showQuickScroll,
                                    setLeftHanded,
                                    leftHanded,
                                    favoriteSearchIndex,
                                    searchParams,
                                    setSearchParams,
                                    updateUser,
                                    updateUserSubscription,
                                    user,
                                    open,
                                    handleClose,
                                    handleLogin,
                                    handleLogout,
                                    blockedSellers,
                                    blockedCountries,
                                    savedSearches,
                                    value,
                                    setValue,
                                    loadingUserData,
                                    subscriptions,
                                    recentItems,
                                    auth,
                                    preferredEbay,
                                    autoRefresh,
                                    setAutoRefresh,
                                    enableShowFirstItem,
                                    setEnableFirstItem,
                                    handleUserData,
                                    hasUpdate,
                                    version,
                                    changelog
                                }) {
    const [privacy, setPrivacy] = useState(false);
    const [settings, setSettings] = useState(false);
    const [feedback, setFeedback] = useState(false);
    const [feedbackSent, setFeedbackSent] = useState(false);
    const [disableRefresh, setDisableRefresh] = useState(false);
    const [showChangeLog, setShowChangelog] = useState(false);
    const versionRef = useRef();
    const showPrivacy = useCallback(() => {
        setPrivacy(true)
    }, [])
    const hidePrivacy = useCallback(() => {
        setPrivacy(false)
    }, []);

    useEffect(()=>{
        if (!versionRef.current) return;
        if (showChangeLog) {
            versionRef.current?.scrollIntoView?.()
        }
    }, [showChangeLog])

    useEffect(() => {
        const visibilityChanged = () => {
            if (!user || loadingUserData) return;
            if (document.visibilityState === 'visible') {
                handleUserData(false, true);
            }
        }
        document.addEventListener('visibilitychange', visibilityChanged);
        return () => {
            document.removeEventListener('visibilitychange', visibilityChanged);
        }
    }, [handleUserData, user, loadingUserData]);

    return (<>
        <Dialog TransitionComponent={Transition} PaperProps={{
            className: "MenuPaper MenuPaperSmall", sx: {
                bottom: 0,
                position: "fixed",
                right: 0,
                left: 0,
                margin: 'auto',
            }
            , style: {maxWidth: "550px", height: user ? "87%" : undefined}
        }} open={open} onClose={handleClose}>
            <DialogTitle sx={{
                paddingBottom: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}>{user ? <div style={{
                display: "flex",
                alignItems: "center", gap: "8px"
            }}>Profile <MobileTooltip enterDelay={500} title={"Refresh"}>
                <IconButton
                    onClick={disableRefresh ? undefined : () => {
                        handleUserData();
                        setDisableRefresh(true);
                        setTimeout(() => {
                            setDisableRefresh(false);
                        }, 2000)
                    }}>
                    <RefreshOutlinedIcon className={"ProfileRefreshIcon"} sx={{
                        animation: "App-logo-spin ease-out 2s infinite",
                        animationPlayState: (disableRefresh ? 'running' : 'paused')
                    }}/>
                </IconButton>
            </MobileTooltip></div> : 'Sign in'}
                <div style={{display: "flex", gap: "8px"}}>
                    {hasUpdate &&
                        <Button onClick={async () => {
                            window.location.reload()
                        }} startIcon={<DownloadingIcon/>}>Update</Button>
                    }
                    <MobileTooltip enterDelay={500} title={"Feedback"}>
                        <IconButton
                            onClick={() => setFeedback(true)}>{feedbackSent ? <MarkChatReadOutlinedIcon/> :
                            <FeedbackOutlinedIcon/>}</IconButton>
                    </MobileTooltip>
                    {user &&
                        <MobileTooltip enterDelay={500} title={"Logout"}>
                            <IconButton onClick={() => {
                                handleLogout();
                                handleClose();
                            }}>
                                <LogoutOutlinedIcon/>
                            </IconButton>
                        </MobileTooltip>
                    }
                    <MobileTooltip enterDelay={500} title={"Settings"}>
                        <IconButton
                            onClick={() => setSettings(true)}><SettingsIcon/></IconButton>
                    </MobileTooltip>
                </div>
            </DialogTitle>
            {
                user ?
                    <ProfileView auth={auth} recentItems={recentItems} value={value} setValue={setValue}
                                 subscriptions={subscriptions} open={open}
                                 searchParams={searchParams} favoriteSearchIndex={favoriteSearchIndex}
                                 setSearchParams={setSearchParams} updateUser={updateUser}
                                 updateUserSubscription={updateUserSubscription} blockedSellers={blockedSellers}
                                 blockedCountries={blockedCountries}
                                 savedSearches={savedSearches} loadingUserData={loadingUserData}
                                 handleClose={handleClose} handleLogout={handleLogout} privacy={showPrivacy}
                                 preferredEbay={preferredEbay}/>
                    :
                    <LoginView handleClose={handleClose} handleLogin={handleLogin} privacy={showPrivacy}/>
            }
        </Dialog>
        <Feedback setFeedback={setFeedback} setFeedbackSent={setFeedbackSent} feedback={feedback}/>
        <Drawer sx={{zIndex: "10000000", margin: "auto", maxWidth: "550px"}}
                PaperProps={{style: {margin: "auto", maxWidth: "550px"}, className: "SidePanel"}} anchor={"right"}
                open={settings}
                onClose={() => setSettings(false)}>
            <List>
                <DialogTitle>
                    Settings
                </DialogTitle>
                <ListItem>
                    <FormControl>
                        <FormLabel component="legend">QuickScroll</FormLabel>
                        <FormGroup>
                            <FormControlLabel control={<Switch checked={enableQuickScroll}
                                                               onClick={() => {
                                                                   localStorage.setItem("enableQuickScroll", enableQuickScroll === true ? "false" : "true");
                                                                   setEnableQuickScroll(!enableQuickScroll);
                                                               }}/>
                            } label="Swipe+Wheel"/>
                            <FormHelperText sx={{maxWidth: "250px"}}>QuickScroll Swipe+Wheel enables scroll gestures to
                                skip through search results.
                                <br/>
                                iOS users should "Add to Home Screen" for the best experience.
                            </FormHelperText>
                            <FormControlLabel control={<Switch checked={showQuickScroll}
                                                               onClick={() => {
                                                                   localStorage.setItem("showQuickScroll", showQuickScroll ? "false" : "true");
                                                                   setShowQuickScroll(!showQuickScroll);
                                                               }}/>
                            } label="Overlay"/>
                            <FormControlLabel control={<Switch disabled={!showQuickScroll} checked={leftHanded}
                                                               onClick={() => {
                                                                   localStorage.setItem("leftHanded", leftHanded ? "false" : "true");
                                                                   setLeftHanded(!leftHanded);
                                                               }}/>
                            } label="Left-handed"/>
                            <FormHelperText sx={{maxWidth: "250px"}}> QuickScroll Overlay enables tap to skip through
                                search results, for use on smaller screens.
                            </FormHelperText>
                        </FormGroup>
                    </FormControl>
                </ListItem> <ListItem>
                <FormControl>
                    <FormLabel component="legend">Refresh</FormLabel>
                    <FormGroup>
                        <FormControlLabel control={<Switch checked={autoRefresh}
                                                           onClick={() => {
                                                               localStorage.setItem("enableAutoRefresh", autoRefresh === true ? "false" : "true");
                                                               setAutoRefresh(!autoRefresh);
                                                           }}/>
                        } label="Auto refresh"/>
                        <FormHelperText sx={{maxWidth: "250px"}}>Auto refresh sidebae after left idle for more than 5
                            minutes.
                            <br/>
                            Auto refresh only runs on newly listed sorted searches and does not run if a panel is open.
                        </FormHelperText>
                        <FormControlLabel control={<Switch checked={enableShowFirstItem}
                                                           onClick={() => {
                                                               localStorage.setItem("enableFirstItem", enableShowFirstItem === true ? "true" : "false");
                                                               setEnableFirstItem(!enableShowFirstItem);
                                                           }}/>
                        } label="New items overlay"/>
                        <FormHelperText sx={{maxWidth: "250px"}}>Shows a 'new items' overlay on the last item seen
                            before the refresh.
                            <br/>
                            The overlay only shows for newly listed sorted searches. A message is also shown with the
                            total count of new items.
                        </FormHelperText>
                        <FormHelperText sx={{maxWidth: "250px"}}>
                            <br/>
                            Keyboard shortcuts<br/>
                            <table className={"ShortcutTable"}>
                                <tr>
                                    <td>
                                        ↑↓
                                    </td>
                                    <td>
                                        QuickScroll/Dismiss item
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        "/" or "?" + ↑↓
                                    </td>
                                    <td>
                                        Query a saved search
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        "s"
                                    </td>
                                    <td>
                                        Show search options
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        ←→
                                    </td>
                                    <td>
                                        Previous or next image
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        "enter"
                                    </td>
                                    <td>
                                        Open in eBay
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        "r"
                                    </td>
                                    <td>
                                        Refresh search
                                    </td>
                                </tr>
                            </table>
                        </FormHelperText>
                    </FormGroup>
                </FormControl>
            </ListItem>
                <ListItem>
                    <Button startIcon={<PrivacyTipOutlinedIcon/>} onClick={showPrivacy}>
                        Privacy Policy
                    </Button>
                </ListItem>
                <ListItem>
                    <div style={{fontSize:"12px", width: "100%", textAlign:"center", marginTop: "1.5em"}}>
                        <div onClick={changelog ? ()=>{setShowChangelog(prev => !prev); } : undefined} style={{userSelect: "none", display: "flex", alignItems: "center", justifyContent:"center", cursor: changelog ? "pointer" : undefined, marginBottom: "-0.5em"}} >
                            <img style={{overflow: "visible", height: "54px", filter: "grayscale(100%)"}}
                                 src={LogoImage} id='logo'
                                 alt={'logo'}/>
                            <Typography  variant={'h5'} sx={{
                                fontSize: "16px",
                                letterSpacing: "-0.5px",
                                fontFamily: "'IBM Plex Sans', 'Roboto'",
                            }}>sidebae <span style={{fontFamily: "Roboto", fontSize: "11px"}}>v{version}</span></Typography>
                        </div>
                        <div style={{fontSize: "11px"}}>made with ❤ by apsm in Vancouver, B.C.</div>
                        <div style={{textAlign: "left", fontSize: "11px"}}>
                            {showChangeLog && <div ref={versionRef} style={{marginTop: "0.5em"}}>
                                {changelog?.split?.(",").map((m, index) => <div style={{opacity: index !== 0 ? 0.5 : 1}}>{m}</div>)}
                            </div>
                            }
                        </div>
                    </div>
                </ListItem>
            </List>
        </Drawer>
        <Privacy privacy={privacy} hidePrivacy={hidePrivacy}/>
    </>);
};

export default Profile;

